internalState